const simpleAgent = [
    { name: 'achieveVictory', maxOrders: -1 },
    { name: 'preventDefeat', maxOrders: -1 },
    { name: 'incurDamage', maxOrders: 2 },
    { name: 'supportFriendlyUnit', maxOrders: -1 },
    { name: 'moveTowardsEnemy', maxOrders: -1 },
    { name: 'supportFriendlyUnit', maxOrders: -1 },
    { name: 'doNothing', maxOrders: -1 },
];
export default simpleAgent;
